





































import { ButtonType } from '@getaccept/lib-ui';
import type { PropType } from '@vue/composition-api';
import { watch, computed, ref, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { SigningStep } from '../../types/signing-step';

export default defineComponent({
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Object as PropType<SigningStep>,
      default: undefined,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const value = ref('');
    const errorMessage = ref('');

    const setError = () => {
      errorMessage.value = props.error
        ? t('wrong-password-please-try-again-or-contact-the-sender').toString()
        : '';
    };

    watch(() => props.error, setError);

    const label = computed(() =>
      props.step && props.step.data.question ? props.step.data.question : t('password')
    );

    const handleChange = () => {
      errorMessage.value = '';
    };

    const close = () => {
      emit('close');
    };

    const verify = () => {
      emit('verify', value.value);
    };

    return {
      ButtonType,
      value,
      errorMessage,
      setError,
      handleChange,
      close,
      verify,
      label,
    };
  },
});
